/**
 * #1809-Fix — Der Device-Token des Stempel-Terminals.
 *
 * Ein Terminal wird EINMALIG gekoppelt (/geraet-einrichten) und traegt danach
 * diesen Token dauerhaft im localStorage. Er reist als Header `x-weship-geraet`
 * mit /api/auth/me und den beiden PIN-Logins mit; der Server loest ihn zu
 * `user.kiosk_device` auf.
 *
 * Der Schluessel wird auch im Anti-Flash-Block in index.html gelesen — dort
 * inline nachgebaut, weil der vor jedem Modul-Import laeuft. Wer ihn hier
 * umbenennt, muss ihn dort mit umbenennen.
 */
const GERAET_TOKEN_KEY = 'weship_kiosk_device_token';
export const GERAET_HEADER = 'x-weship-geraet';

const API = import.meta.env.VITE_API_URL || '';

export function getGeraetToken() {
  if (typeof window === 'undefined') return null;
  try {
    return localStorage.getItem(GERAET_TOKEN_KEY);
  } catch {
    return null;
  }
}

export function setGeraetToken(token) {
  localStorage.setItem(GERAET_TOKEN_KEY, token);
}

export function clearGeraetToken() {
  try {
    localStorage.removeItem(GERAET_TOKEN_KEY);
  } catch { /* Private-Mode o.ae. — dann ist das Geraet ohnehin nicht registriert */ }
}

/** Header-Objekt fuer fetch(); ohne Registrierung leer. */
export function geraetHeaders() {
  const token = getGeraetToken();
  return token ? { [GERAET_HEADER]: token } : {};
}

/**
 * Kopplungscode einloesen (#1820). EINE Einloese-Logik fuer beide Wege — die
 * Einrichtungsseite am Desktop (/geraet-einrichten) und den Einrichtungsschirm
 * im Terminal selbst (/kiosk). Zwei Kopien wuerden auseinanderlaufen, sobald
 * sich das Token-Format oder die Fehlerbehandlung aendert.
 *
 * Der Fehlertext kommt AUS DER ANTWORT, nicht aus dem Aufrufer: der Server
 * unterscheidet ungueltig/abgelaufen (404), Formatfehler (400) und zu viele
 * Versuche (429) — ein pauschales „Kopplung fehlgeschlagen" waere die
 * Sackgasse, die es nicht geben soll.
 *
 * @returns {Promise<{ok:true,name:string,standort:string|null}|{ok:false,error:string}>}
 */
export async function koppleGeraet(code) {
  const bereinigt = String(code || '').replace(/\D/g, '');
  try {
    const res = await fetch(`${API}/api/kiosk-geraete/koppeln`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ code: bereinigt }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok || !data.token) {
      return { ok: false, error: data.error || 'Kopplung fehlgeschlagen' };
    }
    setGeraetToken(data.token);
    return { ok: true, name: data.name, standort: data.standort ?? null };
  } catch {
    return { ok: false, error: 'Keine Verbindung zum Server' };
  }
}
